module.exports = "/assets/data/47de0e3946749ba951a539b2a0101662-S7.data.json";